import api from "../request";
import { Promise } from "q";
import constants from "../../utils/constants";
import Vue from "vue";
import VueCookies from 'vue-cookies';
Vue.use(VueCookies, { expire: '30d'})

function create(user) {
    return api.post("users", user).catch((err) => {
        const { response } = err;
        const error =
            (response && response.data && response.data.error) ||
            response.statusText;
        return Promise.reject(error);
    });
}

function logIn(reqData) {
    return api.post("users/login", { reqData }).then(({ data }) => {
        if (data.responseData.token) {
            sessionStorage.setItem("auth_token", data.responseData.token);
            sessionStorage.setItem(
                "user",
                JSON.stringify(data.responseData.user)
            );
            if (reqData.keepMeLoggedIn && data.responseData.user.institute === constants.ONLINE_INSTITUTE_ID) {
                localStorage.setItem("auth_token", data.responseData.token);
                localStorage.setItem(
                    "user",
                    JSON.stringify(data.responseData.user)
                );
            }
        }
        return data;
    });
}

function checkUserName(username, password) {
    let reqData = { username };
    return api
        .post("users/username/check", { reqData })
        .then(({ data }) => {
            return data;
        })
        .catch(({ data }) => {
            return Promise.reject(data);
        });
}
function createUserNameAndPassword(reqData) {
    return api.post("users/username/create", { reqData }).then(({ data }) => {
        return data;
    });
}
function forgotPassword(reqData) {
    return api.post("users/password/new", { reqData }).then(({ data }) => {
        return data;
    });
}

function logOut() {
    return api.get("users/logout").then(({ data }) => {
        sessionStorage.clear();
        localStorage.removeItem('user')
        localStorage.removeItem('auth_token')
        VueCookies.remove('userToken',constants.COOKIE_PATH,constants.COOKEI_DOMAIN);
        VueCookies.remove('keepMeLoggedIn',constants.COOKIE_PATH,constants.COOKEI_DOMAIN);
        VueCookies.remove('isShowErrorMsg',constants.COOKIE_PATH,constants.COOKEI_DOMAIN);
        VueCookies.remove('upgrade',constants.COOKIE_PATH,constants.COOKEI_DOMAIN);
        VueCookies.remove('isLoggedIn',constants.COOKIE_PATH,constants.COOKEI_DOMAIN);
        return data;
    });
}

function me() {
    return api.get("users/me");
}

function getInstituteDetails() {
    return api.get("institute/info");
}

function resetPassword(reqData) {
    return api.post("users/password/reset", { reqData }).then(({ data }) => {
        return data;
    });
}
function resetPasswordByUserId(reqData) {
    return api
        .post("users/external/password/reset", { reqData })
        .then(({ data }) => {
            return data;
        });
}
function verifyOTP(reqData) {
    return api
        .post("users/otp/verify", { reqData })
        .then(({ data }) => {
            return data;
        })
        .catch(({ data }) => {
            return Promise.reject(data);
        });
}
function getExternalRoles(reqData) {
    return api.get(`roles/all?type=e${reqData.mytUser ? `&myt_user=true` : ''}`);
}
function signUp(reqData) {
    if (reqData.internal) {
        return api
            .post("users/create-external-user", { reqData })
            .then(({ data }) => {
                return data;
            });
    } else {
        return api.post("users/signup", { reqData }).then(({ data }) => {
            return data;
        });
    }
}

function getClasses() {
    return api.get("ref/getClasses");
}

function getSelfSignedUpUsers(reqData) {
    return api
        .post("users/get-external-users", { reqData })
        .then(({ data }) => {
            return data;
        });
}
function approveOrDisapproveUser(reqData) {
    return api
        .post("users/update-approved-status", { reqData })
        .then(({ data }) => {
            return data;
        });
}
function approveOrSaveStudent(reqData) {
    return api
        .post("users/approve-or-save-student", { reqData })
        .then(({ data }) => {
            return data;
        });
}
function setUserActiveStatus(reqData) {
    return api.post("users/external/active", { reqData }).then(({ data }) => {
        return data;
    });
}
function allocateBatch(reqData) {
    return api
        .post("users/external/allocate-batch", { reqData })
        .then(({ data }) => {
            return data;
        });
}
function changePassword(reqData) {
    return api.post("users/password/change", { reqData }).then(({ data }) => {
        return data;
    });
}
function updateProfile(formData) {
    return api
        .post("users/profile/update", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then(({ data }) => {
            return data;
        })
        .catch(({ data }) => {
            return Promise.reject(data);
        });
}
function updateExternalUser(reqData) {
    return api
        .post("users/external/update-user", { reqData })
        .then(({ data }) => {
            return data;
        });
}
function updateUserActivity(reqData) {
    return api
        .post("activities/duration/save", { reqData })
        .then(({ data }) => {
            return data;
        });
}
function getPackages(reqData) {
    return api.post("product/get", { reqData }).then(({ data }) => {
        return data;
    });
}
function createPackageOrder(reqData) {
    return api.post("product/create-order", { reqData }).then(({ data }) => {
        return data;
    });
}
function getListOfPendingTests(reqData) {
    return api.post("test/pending", { reqData }).then(({ data }) => {
        return data;
    });
}
function updateTransactionStatus(reqData) {
    return api.post("product/cancel-order", { reqData }).then(({ data }) => {
        return data;
    });
}
function getUserByEmail(reqData) {
    return api.post("users/get-user-by-email", { reqData }).then(({ data }) => {
        return data;
    });
}
function deleteUser(reqData) {
    return api.post("users/delete-user", { reqData }).then(({ data }) => {
        return data;
    });
}
function getTeacherDetails(reqData) {
    return api
        .post("users/get-teacher-details", { reqData })
        .then(({ data }) => {
            return data;
        });
}
function getUserPurchasedModules(reqData) {
    return api
        .post("users/get-user-purchased-modules", { reqData })
        .then(({ data }) => {
            return data;
        });
}
function getSubjectUsers(reqData) {
    return api
        .post("users/get-subject-users", { reqData })
        .then(({ data }) => {
            return data;
        });
}
function getTeacherSubject(reqData) {
    return api
        .get("users/get-teacher-subject-tree")
        .then(({ data }) => {
            return data;
        });
}
function validateEmail(reqData) {
    return api
        .post("users/validate-email",{reqData})
        .then(({ data }) => {
            return data;
        });
}
function addLicenseSubscription(reqData) {
    return api
        .post("institute/subscription/add-licence",{reqData})
        .then(({ data }) => {
            return data;
        });
}
function renewSubscription(reqData) {
    return api
        .post("institute/subscription/renew",{reqData})
        .then(({ data }) => {
            return data;
        });
}
function verifyOTPWebsite(reqData) {
    return api
        .post("users/website/verify-otp", { reqData })
        .then(({ data }) => {
            return data;
        })
        .catch(({ data }) => {
            return Promise.reject(data);
        });
}
function resendOtpWebsite(reqData) {
    return api
        .post("users/website/resend-otp", { reqData })
        .then(({ data }) => {
            return data;
        })
        .catch(({ data }) => {
            return Promise.reject(data);
        });
}
function verifyCoupon(reqData) {
    return api.post("coupon/verify", { reqData }).then(({ data }) => {
        return data;
    });
}
function applyCoupon(reqData) {
    return api.post("coupon/apply", { reqData }).then(({ data }) => {
        return data;
    });
}
function getPriceDetails(reqData) {
    return api.post("product/get-price-details" ,{reqData}).then(({ data }) => {
        return data;
    }) 
}
function loginMyt(reqData) {
    return api.post("myt/login" ,{reqData}).then(({ data }) => {
        if (data.responseData.token && reqData.password) {
            localStorage.removeItem("guest_user_id");
            sessionStorage.setItem("auth_token", data.responseData.token);
            sessionStorage.setItem(
                "user",
                JSON.stringify(data.responseData.user))
        }
        return data;
    }) 
}
function resendOtpMyt(reqData) {
    return api.post("myt/resend" ,{reqData}).then(({ data }) => {
        return data;
    }) 
}
function verifyOtpMyt(reqData) {
    return api.post("myt/verify" ,{reqData}).then(({ data }) => {
        if (!data.responseData.isNewUser) {
            localStorage.removeItem("guest_user_id");

            sessionStorage.setItem("auth_token", data.responseData.token);
            sessionStorage.setItem(
                "user",
                JSON.stringify(data.responseData.user))
        }
        return data;
    }) 
}
function signupMyt(reqData) {
    return api.post("myt/signup" ,{reqData}).then(({ data }) => {
        if (data.responseData.isNewUser) {
            
            sessionStorage.setItem("auth_token", data.responseData.token);
            sessionStorage.setItem(
                "user",
                JSON.stringify(data.responseData.user))
        }
        return data;
    }) 
}
function logOutMyt(reqData) {
    return api.get("myt/logout").then(({ data }) => {
        sessionStorage.clear();
        localStorage.removeItem('user')
        localStorage.removeItem('auth_token')
        return data;
    });
}

function importStudents(reqData) {
    return api.post("users/students/import", reqData).then(({ data }) => {
        return data;
    });
}
function downloadStudentTemplate(reqData) {
    return api.get("users/students/download-template", {responseType: 'blob'}).then(({ data }) => {
        return data;
    });
}

export default {
    create,
    logIn,
    logOut,
    checkUserName,
    createUserNameAndPassword,
    forgotPassword,
    getInstituteDetails,
    resetPassword,
    verifyOTP,
    getExternalRoles,
    signUp,
    getSubjectUsers,
    me,
    getClasses,
    getSelfSignedUpUsers,
    approveOrDisapproveUser,
    approveOrSaveStudent,
    setUserActiveStatus,
    allocateBatch,
    changePassword,
    updateProfile,
    updateExternalUser,
    updateUserActivity,
    getPackages,
    createPackageOrder,
    getListOfPendingTests,
    updateTransactionStatus,
    getUserByEmail,
    resetPasswordByUserId,
    deleteUser,
    getTeacherDetails,
	getUserPurchasedModules,
	getTeacherSubject,
	validateEmail,
	addLicenseSubscription,
	renewSubscription,
    verifyOTPWebsite,
    resendOtpWebsite,
    verifyCoupon,
    applyCoupon,
    getPriceDetails,
    loginMyt,
    signupMyt,
    verifyOtpMyt,
    resendOtpMyt,
    logOutMyt,
    importStudents,
    downloadStudentTemplate
};
